// extracted by mini-css-extract-plugin
module.exports = {"interview":"Interview_interview__RCtU2"};